import {
  GET_BATCHES_REQUEST,
  GET_BATCHES_SUCCESS,
  GET_BATCHES_ERROR,
  CREATE_BATCH_REQUEST,
  CREATE_BATCH_SUCCESS,
  CREATE_BATCH_ERROR,
  UPDATE_BATCH_REQUEST,
  UPDATE_BATCH_SUCCESS,
  UPDATE_BATCH_ERROR,
  ARCHIVE_BATCHES_REQUEST,
  ARCHIVE_BATCHES_SUCCESS,
  ARCHIVE_BATCHES_ERROR
} from "../actions/aegean_batch_runs";

import { appendOrReplaceEntity } from "@utils/reducers";

const defaultState = {};

export default (state = defaultState, action) => {
  switch (action.type) {
    case GET_BATCHES_REQUEST:
    case CREATE_BATCH_REQUEST:
    case UPDATE_BATCH_REQUEST:
    case ARCHIVE_BATCHES_REQUEST: {
      const { workspace_id } = action;

      const statePiece = {
        ...state[workspace_id],
        isFetching: true
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }

    case GET_BATCHES_SUCCESS:
    case ARCHIVE_BATCHES_SUCCESS: {
      const { data, workspace_id } = action;

      const statePiece = {
        ...state[workspace_id],
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }

    case CREATE_BATCH_SUCCESS:
    case UPDATE_BATCH_SUCCESS: {
      const { data, workspace_id } = action;

      const statePiece = {
        ...state[workspace_id],
        isFetching: false,
        fetchedAt: new Date(),
        error: null,
        data: appendOrReplaceEntity(state[workspace_id] && state[workspace_id].data, data)
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }

    case GET_BATCHES_ERROR:
    case CREATE_BATCH_ERROR:
    case UPDATE_BATCH_ERROR:
    case ARCHIVE_BATCHES_ERROR: {
      const { error, workspace_id } = action;

      const statePiece = {
        ...state[workspace_id],
        isFetching: false,
        error
      };

      return {
        ...state,
        [workspace_id]: statePiece
      };
    }

    default: return state;
  }
};
